import React, { useEffect, useContext } from "react"

import { Row, Col } from "react-bootstrap"

import { FETCH_RELATED_ARTICLES } from "../blog-actions/blog-actions"

import { GlobalAuthContext } from "../../../context/authContext"

import SinglePost from "../../acf-blocks/single-post/single-post"
import "./related-articles.scss"

const RelatedArticles = ({ categories, slug }) => {
  const { state, dispatch } = useContext(GlobalAuthContext)

  useEffect(() => {
    FETCH_RELATED_ARTICLES(dispatch, categories[0], slug)
  }, [categories]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {state?.related && (
        <div className="related-articles mb-3">
          <h4 className="title">Related Articles</h4>
          <div className="list">
            <Row>
              {state?.related?.slice(0, 4)?.map((post, index) => {
                return (
                  <Col lg="3" sm="6" key={index}>
                    <SinglePost post={post} related={true} />
                  </Col>
                )
              })}
            </Row>
          </div>
        </div>
      )}
    </>
  )
}

export default RelatedArticles
